module.exports = __webpack_public_path__ + "img/primary_8x2.bd330204.svg";